<template>
<v-list-tile-avatar>
  <img :src="functypeIcon">
  <img v-if="isOffline" :src="require('../../assets/red_circle.svg')" style="position:absolute"></img>
</v-list-tile-avatar>
</template>

<script>
export default {
  name: 'DeviceAvatar',
  props: {
    item: {
      type: Object,
      required: true
    },
    eventlog: {
      type: Object,
      required: true
    }
  },
  computed: {
    functypeIcon() {
      return this.$FuncTypeIcons[this.item.functype] || this.$FuncTypeIcons['unknown'];
    },
    isOffline() {
      return new Date().getTime() - this.eventlog.timestamp * 1000 > 24 * 60 * 60 * 1000;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceAvatar.vue